module.exports = __webpack_public_path__ + "media/images/front/common/userIcon-f1e226d1744c2b786f500c73decc11d1.png";